import React from 'react';
import track from 'react-tracking';

import createAssignmentStoreV2 from '../CreateAssignment.store';

import {ShareAssignmentList} from 'client/components/ContentDiscovery/Document/AssignmentSharing/AssignmentSharing.react';

@track({component: 'Step 3: Success', feature: 'ACF'})
export default class CreateAssignmentConfirmation extends React.Component {
  componentDidMount() {
    global.scrollTo(0, 0);
  }

  render() {
    const assignments = createAssignmentStoreV2.getSavedAssignmentPayload();

    return <ShareAssignmentList assignments={assignments} />;
  }
}
